import common from '@namespace/common/index'
// import top from '@namespace/top/index'

common()
// top()
